"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var csod = require("player-core");
function view() {
    var _this = this;
    return {
        state: {
            resultsHeaderText: csod.locales.get("Current Openings", "Current Openings"),
            createJobAlertBtnText: csod.locales.get("Create an alert", "Create an alert"),
            sortDropDownText: csod.locales.get("Sort By", "Sort By"),
            prevButtonAriaLabel: csod.locales.get("Previous Page", "Previous Page"),
            nextButtonAriaLabel: csod.locales.get("Next Page", "Next Page"),
            showPagination: this.props.totalPages > 1
        },
        initialize: function () {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        mounted: function () {
        },
        receivedProps: function (nextProps) {
            return new Promise(function (resolve) {
                if (nextProps.hasSearched) {
                    if (nextProps.totalSearchResults == 1) {
                        _this.view.state.resultsHeaderText = csod.locales.get("1 Job Found", "1 Job Found");
                    }
                    else {
                        _this.view.state.resultsHeaderText = csod.locales.get("{0} Jobs Found", "{0} Jobs Found", nextProps.totalSearchResults);
                    }
                }
                else {
                    _this.view.state.resultsHeaderText = csod.locales.get("Current Openings", "Current Openings");
                }
                _this.view.state.showPagination = nextProps.totalPages > 1;
                _this.view.state.list = nextProps.selectedFilterFlaglist;
                _this.view.state.createJobAlertBtnVisible = csod.viewModel.showCreateAlertsButton ? csod.viewModel.showCreateAlertsButton : false;
                _this.view.state.createJobAlertBtnText = csod.locales.get("Create an alert", "Create an alert");
                resolve();
            });
        },
        unmount: function () {
        },
        events: {
            onCreateJobAlert: this.props.onCreateJobAlert,
            onSortSelect: this.props.onSortSelect,
            onSortOpen: this.props.onSortOpen,
            onPageNavigate: this.props.onPageNavigate,
            onCloseJobAlertModal: this.props.onCloseJobAlertModal,
            onJobAlertTitleChange: this.props.onJobAlertTitleChange,
            onJobAlertFrequencyChange: this.props.onJobAlertFrequencyChange,
            onCreateJobAlertBtnClick: this.props.onCreateJobAlertBtnClick,
            onCancelJobAlertCreation: this.props.onCancelJobAlertCreation,
            onFilterFlagCloseClick: this.props.onFilterFlagCloseClick,
            onCloseEmailValidationErrorModal: this.props.onCloseEmailValidationErrorModal
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/f257358f111b2299/src/.tmp/JobSearchResults/View.js
// module id = 763
// module chunks = 0